import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import Sidebar from "./Sidebar";
import BreadCrumb from "./BreadCrumb";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal, Button, Form } from "react-bootstrap";

function AddPins() {
  const { id } = useParams();
  const [totalPins, setTotalPins] = useState(0);
  const [costPerPins, setcostPerPins] = useState(0);
  const [pinData, setPinData] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newPinQty, setNewPinQty] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchPins();
  }, []);

  useEffect(() => {
    const result = pinData.filter((row) =>
      Object.values(row).some((value) =>
        value.toString().toLowerCase().includes(search.toLowerCase())
      )
    );
    setFilteredData(result);
  }, [search, pinData]);

  const fetchPins = async () => {
    try {
      const response = await axios.get(`${baseurl}stateHeadPins/${id}`);
      setTotalPins(response.data.totalPins);
      setcostPerPins(response.data.costPerPin);
      setPinData(response.data.pinData);
      setFilteredData(response.data.pinData);
    } catch (error) {
      console.error("Error fetching pin data:", error);
    }
  };

  const handleAddPin = async () => {
    if (!newPinQty) {
      alert("Please enter pin quantity.");
      return;
    }
  
    const requestData = {
      user_id: id,
      cost_per_pin: costPerPins,
      pin_qty: newPinQty,
    };
  
    console.log("Sending data to backend:", requestData); // Log data before request
  
    try {
      const response = await axios.post(`${baseurl}addpinstostatehead`, requestData);
  
      console.log("Response from backend:", response.data); // Log response
  
      if (response.data.success) {
        alert("Pins added successfully!");
        fetchPins(); // Refresh the table
        setShowModal(false);
        setNewPinQty(""); // Reset input field
      } else {
        alert("Failed to add pins.");
      }
    } catch (error) {
      console.error("Error adding pins:", error);
      alert("An error occurred. Please try again.");
    }
  };
  

  const columns = [
    { name: "User Type", selector: (row) => row.user_type, sortable: true },
    { name: "Pin Qty", selector: (row) => row.pin_qty, sortable: true },
    { name: "Cost Per Pin", selector: (row) => `₹${row.cost_per_pin}`, sortable: true },
    { name: "Total Amount", selector: (row) => `₹${row.total_amount}`, sortable: true },
    { name: "Created At", selector: (row) => new Date(row.created_at).toLocaleString(), sortable: true },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <Sidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <BreadCrumb />
        <div className="container-fluid">
          <div className="crdmain mb-2">
            <div className="d-flex justify-content-between align-items-center mb-3" style={{ width: "100%" }}>
              <h2 className="chart-title mb-0">State Head Pins</h2>

              <Button variant="primary" className="ms-auto" onClick={() => setShowModal(true)}>+ Add Pins</Button>
            </div>

            {/* Total Pins Box */}

            <div className="row g-2 mb-3">
                <div className="col-md-3 ">
                    <div className="p-3 border rounded ">
                    <h4>Total Pins</h4>
                    <h2 style={{ fontWeight: "bold", color: "#007bff" }}>{totalPins}</h2>
                    </div> 
                </div>
            </div>
             

            {/* Search Input */}
            <input
              type="text"
              placeholder="Search..."
              className="form-control mb-3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            {/* Data Table */}
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
              />
            </div>
          </div>
        </div>
      </div>

      {/* Add Pins Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Pins</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="pinQty">
              <Form.Label>Enter Pin Quantity</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter pin quantity"
                value={newPinQty}
                onChange={(e) => setNewPinQty(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleAddPin}>Add</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AddPins;
